// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/less/popup.less
// module id = 1201
// module chunks = 0